import { SelectBoxManager } from "./select-box-manager";
import { tryParseInt } from "./input-utils";

interface NotificationListConfiguration {
    ids: {
        userIdInput: string;
        locationIdInput: string;
        deviceIdInput: string;
    };
    userId: string | undefined;
    locationId: number | undefined;
    deviceId: number | undefined;
}

$(document).on("turbolinks:load", async function() {
    const configElement = document.getElementById("notification-list-config");
    if (configElement) {
        const config: NotificationListConfiguration = JSON.parse(configElement.innerHTML);
        const page = new NotificationListPage(config);
        await page.initialise();
        $(document).one("turbolinks:before-render", () => page.destroy());
    }
});

export class NotificationListPage {
    private $userInput: JQuery;
    private $locationInput: JQuery;
    private $deviceInput: JQuery;
    private selectBoxManager: SelectBoxManager = new SelectBoxManager();

    constructor(private config: NotificationListConfiguration) {
        this.$userInput = $("#" + config.ids.userIdInput);
        this.$locationInput = $("#" + config.ids.locationIdInput);
        this.$deviceInput = $("#" + config.ids.deviceIdInput);

        this.$locationInput.on("change", this.onLocationChange.bind(this));
    }

    public async initialise() {
        await this.selectBoxManager.initialise();
        this.selectBoxManager.setOptions(this.$locationInput, this.selectBoxManager.allLocations, this.config.locationId, true);
        this.selectBoxManager.setOptions(this.$userInput, this.selectBoxManager.getUsersForLocation(this.config.locationId), this.config.userId, true);
        this.selectBoxManager.setOptions(this.$deviceInput, this.selectBoxManager.getDevicesForLocation(this.config.locationId), this.config.deviceId, true)
    }

    public destroy() {
    }

    private onLocationChange() {
        const locationId = tryParseInt(this.$locationInput.val());
        this.selectBoxManager.setOptions(this.$deviceInput, this.selectBoxManager.getDevicesForLocation(locationId), null, true);
        this.selectBoxManager.setOptions(this.$userInput, this.selectBoxManager.getUsersForLocation(locationId), null, true);
    }
}
